var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrs-typography",attrs:{"id":"main"}},[_c('div',{staticClass:"app__container",attrs:{"id":"app-container"}},[_c('Calculator')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }